import { Errors } from "../errors";
export function checkNullParameter(argument, name, sec) {
    if (argument == undefined) {
        sec.throwError('TypeError', Errors.NullPointerError, name);
    }
}
